import { UiStyle } from "../enums/ui-style";
import { UISearchDefinitionModel, UIPropertyModel, UIFieldSetModel, UISearchFieldModel } from "e5core-angular-services";
import { FieldSetModel } from "./field-set.model";
import { UISearchZoneModel } from "e5core-angular-services";

export class SearchFormModel implements FieldSetModel {
    ui: UiStyle ;

    searchDefinitionId:number;
    name: string ;
    pageSize: number;
    page: number ;
    zones: UISearchZoneModel[];
    zoneTemplateId: string ;
    searchFields:UISearchFieldModel[];

    // from FieldSetModel
    fieldsets : UIFieldSetModel[] ;
    properties : UIPropertyModel[] ;
}

export function CreateBlankSearchForm(): SearchFormModel {
    let model = new SearchFormModel()
    model.ui = UiStyle.Material ;
    return (model) ;
}